import ChalkySticks from '@chalkysticks/sdk';

/**
 * @type interface
 */
export interface IStoreState {
	activeTableState: any;
	completedTutorial: boolean;
	diagramState: ChalkySticks.Pad.Enum.DiagramState;
	savedImageUrl: string;
	showSuccess: boolean;
}

/**
 * @class State
 * @package Store
 * @project ChalkySticks Pad
 */
const state: IStoreState = {
	activeTableState: {
		ballCount: 0,
		ballType: 'chalkysticks',
		balls: [],
		cues: [],
		isComplete: false,
		layout: {},
		lines: [],
		shapes: [],
		tableType: 'table-horizontal-9',
		texts: [],
		trajectories: [],
	},
	completedTutorial: false,
	diagramState: ChalkySticks.Pad.Enum.DiagramState.None,
	savedImageUrl: '',
	showSuccess: false,
};

export default state;
